import React from 'react';
import './New.css';

const New = ({ image, title, pubDate, quote }) => {
  return (
    <div className="New">
      <div
        style={{ backgroundImage: `url(${image})` }}
        className="New__image"
      />
      <div className="New__title">{title}</div>
      <div className="New__pubDate">{pubDate}</div>
      <div
        className="New__quote"
        dangerouslySetInnerHTML={{ __html: quote }}
      ></div>
      <div className="New__filter"></div>
    </div>
  );
};

export default New;
